import './style.scss';
import Chart from 'chart.js';

const valuesMoore = [0, 1, 3, 6, 10, 15, 21, 28, 36, 45, 55, 66, 78, 91, 105];
const valuesRogers = [0, 1, 4, 11, 26, 57, 120, 247, 502, 1013, 2036, 4083, 8178, 16369, 32752];
const valuesBell = [
    1,
    2,
    5,
    15,
    52,
    203,
    877,
    4140,
    21147,
    115975,
    678570,
    4213597,
    27644437,
    190899322,
    1382958545
];

const participantsInput = document.getElementById('participants') as HTMLInputElement;
const logarithmicInput = document.getElementById('logarithmic') as HTMLInputElement;

let chart: Chart;

const config: Chart.ChartConfiguration = {
    type: 'line',
    data: {
        datasets: [
            {
                label: 'Moore',
                backgroundColor: 'rgba(136, 14, 79, 1)',
                borderColor: 'rgba(173, 19, 87, 0.5)',
                fill: false
            },
            {
                label: 'Rogers',
                backgroundColor: 'rgba(1, 87, 155, 1)',
                borderColor: 'rgba(1, 87, 155, 0.5)',
                fill: false
            },
            {
                label: 'Bell',
                backgroundColor: 'rgba(27, 94, 32, 1)',
                borderColor: 'rgba(27, 94, 32, 0.5)',
                fill: false
            }
        ]
    },
    options: {
        responsive: true,
        aspectRatio: 1.8,
        title: {
            display: true,
            text: 'Modellvergleich zu Interaktionssystemen einer Gruppe'
        },
        scales: {
            xAxes: [
                {
                    display: true
                }
            ],
            yAxes: [
                {
                    display: true,
                    type: logarithmicInput.checked ? 'logarithmic' : 'linear'
                }
            ]
        }
    }
};

const populateChartbyParticipants = (
    data: Chart.ChartData = chart.data,
    participants: number = +participantsInput.value
) => {
    if (participants > 15 || participants < 1) return;

    data.labels = Array.from(new Array(participants), (_, i) => i + 1 + '');
    data.datasets[0].data = valuesMoore.slice(0, participants);
    data.datasets[1].data = valuesRogers.slice(0, participants);
    data.datasets[2].data = valuesBell.slice(0, participants);
};

window.onload = function() {
    var ctx = (document.getElementById('canvas') as HTMLCanvasElement).getContext('2d');
    populateChartbyParticipants(config.data);
    chart = new Chart(ctx, config);
};

participantsInput.addEventListener('input', _ => {
    populateChartbyParticipants();
    chart.update();
});

logarithmicInput.addEventListener('input', _ => {
    chart.config.options.scales.yAxes[0].type = logarithmicInput.checked ? 'logarithmic' : 'linear';
    chart.update();
});
